import styled from "@emotion/styled"
import { Box } from "@mui/system"
import { CircularProgress, Typography } from "@mui/material"
import CustomButton from "../custom-button/custom-button.component"
import CustomInput from "../custom-input/custom-input.component"

export const FormSpinner = styled(Box)`
  position: absolute;
  left: 5px;
  right: 0;
  top: 19px;
  bottom: 0;
  width: 17%;
  height: 17%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const CustomSpinner = styled(CircularProgress)`
  color: ${({ theme }) => theme.palette.text.primary};
  width: 15px !important;
  height: 15px !important;
`

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 475px;
    flex-direction: column;
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: row;
  }
`

export const Button = styled(CustomButton)`
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  margin: 1rem;
  background-color: white;
  color: #191d23;
  border-radius: 100px;
  padding: 10px 5px;
  white-space: nowrap;
  text-transform: none;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 19px !important;
  height: 48px;

  &:hover {
    background-color: #e8e5e5 !important;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
    margin-top: 1.5rem;
  }
`

export const InputText = styled(CustomInput)`
  input {
    color: white !important;
  }

  .MuiFormHelperText-root {
    position: absolute;
    bottom: -20px;
  }

  .MuiOutlinedInput-root {
    border-radius: 100px;
    height: 48px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(255, 255, 255, 0.4) !important;
  }
`

export const ErrorMessage = styled(Typography)`
  color: #f34f4f;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
`
